import { render, staticRenderFns } from "./UserRoleForm.vue?vue&type=template&id=0d7d67d0&scoped=true&"
import script from "./UserRoleForm.vue?vue&type=script&lang=js&"
export * from "./UserRoleForm.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleForm.vue?vue&type=style&index=0&id=0d7d67d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7d67d0",
  null
  
)

export default component.exports